import React from 'react';
import TableRow from "@mui/material/TableRow";
import Skeleton from '@mui/material/Skeleton';
import TableCell from "@mui/material/TableCell";
import EditIcon from "@mui/icons-material/Edit";
import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";
import Grid from "@mui/material/Grid";
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import Typography from "@mui/material/Typography";
import moment from "moment";
import Chip from "@mui/material/Chip";
import {getSiteEventEditRoute} from "../../../../../router/routes/site/factory/planner";
import Button from "../../../inputs/Button";

const Row = ({event, loading}) => {
    const {t} = useTranslation();
    const displayEvent = (!loading && event);

    return (
        <TableRow>
            <TableCell>
                {!displayEvent && <Skeleton variant="circular" width={40} height={40}/>}
                {(displayEvent && event.Visible === 'Y') && <VisibilityIcon/>}
                {(displayEvent && event.Visible === 'N') && <VisibilityOffIcon/>}
            </TableCell>
            <TableCell>
                {!displayEvent && <Skeleton/>}
                {displayEvent && <Grid container direction='column'>
                    <Typography variant='h6'>
                        {moment(parseInt(event.Event_Date.unixms)).format('LL')}
                    </Typography>
                    <Typography variant='subtitle1'>
                        {moment(parseInt(event.Event_Date.unixms)).format('LT')}
                    </Typography>
                </Grid>}
            </TableCell>
            <TableCell>
                {!displayEvent && <Skeleton/>}
                {(displayEvent) && <span>{event.Schedule.Content_Cms_Entry_Data.Title}</span>}
            </TableCell>
            <TableCell>
                {!displayEvent && <Skeleton/>}
                {(displayEvent) && <span>{t('event_capacity_summary', {count: event.Total_Count, capacity:event.Total_Capacity})}</span>}
            </TableCell>
            <TableCell>
                {!displayEvent && <Skeleton/>}
                {(displayEvent && event.Schedule.Tags) &&
                <Grid container spacing={3}>
                    {event.Schedule.Tags.map(t => <Grid item><Chip variant='outlined' color='primary'
                                                                            label={t.Name}/></Grid>)}
                </Grid>
                }
            </TableCell>
            <TableCell align="right">
                {!displayEvent && <Skeleton/>}
                {(displayEvent) && <Button
                    variant="contained"
                    color="primary"
                    startIcon={<EditIcon/>}
                    component={Link} to={getSiteEventEditRoute(event.Planner_Event__)}
                >
                    {t('edit_btn')}
                </Button>}

            </TableCell>
        </TableRow>
    );
};

export default Row;
